export const GET_RECIPE_INFO = "GET_RECIPE_INFO";
export const SEARCH_VALUE = "SEARCH_VALUE";

export const GET_EQUIPMENTS = "GET_EQUIPMENTS";
export const SET_FAV = "SET_FAV";
export const SORT_RECIPES = "SORT_RECIPES";
export const REMOVE_RECIPE = "REMOVE_RECIPE";
export const CLEAR_RECIPE = "CLEAR_RECIPE";
export const SET_ERROR = "SET_ERROR";
export const REMOVE_ERROR = "REMOVE_ERROR";
